import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { NgModule } from '@angular/core';

import { AddTaskComponent } from './add-task/add-task.component';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CommandBarComponent } from './command-bar/command-bar.component';
import { CreateTaskComponent } from './create-task/create-task.component';
import { EditTaskComponent } from './edit-task/edit-task.component';
import { EditTaskFormComponent } from './edit-task-form/edit-task-form.component';
import { MysprintsComponent } from './mysprints/mysprints.component';
import { MytasksComponent } from './mytasks/mytasks.component';
import { TaskDetailsComponent } from './task-details/task-details.component';
import { TaskStateLabelComponent } from './task-state-label/task-state-label.component';
import { SprintDetailsComponent } from './sprint-details/sprint-details.component';

@NgModule({
  declarations: [
    AddTaskComponent,
    AppComponent,
    CommandBarComponent,
    CreateTaskComponent,
    EditTaskComponent,
    EditTaskFormComponent,
    MysprintsComponent,
    MytasksComponent,
    SprintDetailsComponent,
    TaskDetailsComponent,
    TaskStateLabelComponent,
  ],
  imports: [
    AppRoutingModule,
    BrowserAnimationsModule,
    BrowserModule,
    FormsModule,
    MatButtonModule,
    MatCheckboxModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    MatSortModule,
    MatTableModule,
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
